export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/generic.69e638f.svg";